import { philosopher } from "@/lib/fonts";
import { cn } from "@/lib/utils";
import { routes } from "@/lib/constants";
import { Heart, ShoppingBasket } from "lucide-react";
import { Link } from "react-router-dom";
import BackButton from "./BackButton";
import Search from "./Search";

interface ButtonsHeaderProps {
  heading: string;
  showButtons?: boolean;
  onBack?: () => void;
}

export default function ButtonsHeader({
  heading,
  showButtons = true,
  onBack,
}: ButtonsHeaderProps) {
  return (
    <div className="flex px-4 justify-between items-center mb-4">
      <div className={cn("flex items-center gap-3", showButtons ? "" : "grow")}>
        <BackButton onBack={onBack} />
        <div className="grow">
          <h1
            className={cn(
              "text-xl font-semibold line-clamp-1",
              philosopher.className,
              showButtons ? "text-left" : "text-center",
            )}
          >
            {heading}
          </h1>
        </div>
      </div>
      {showButtons ? (
        <div className="flex justify-end items-center gap-3">
          <Link
            to={routes.cart}
            className="bg-white rounded-full p-2 cursor-pointer shadow-md"
          >
            <ShoppingBasket strokeWidth={1} />
          </Link>
          <Search iconOnly />
          <Link
            to={routes.wishlist}
            className="bg-white rounded-full p-2 cursor-pointer shadow-md"
          >
            <Heart strokeWidth={1} />
          </Link>
        </div>
      ) : null}
    </div>
  );
}
